import React from 'react';
import { TextV2, TextV2Props } from '@withjoy/joykit';
import { CountdownFormat, useCountdown } from '@localization/hooks/useCountdown';
import { GuestSiteTypographyOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride';
import { label4ToCaptionOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride.constants';

interface InternalEventCountdownProps {
  timezone?: string;
  milliseconds: number;
  countdownFormat?: CountdownFormat;
}

interface EventCountdownProps extends Readonly<InternalEventCountdownProps>, TextV2Props {}

const EventCountdown: React.FC<EventCountdownProps> = ({ milliseconds, countdownFormat, ...restProps }) => {
  const { formattedDuration } = useCountdown(milliseconds, countdownFormat);

  return (
    <GuestSiteTypographyOverride override={label4ToCaptionOverride}>
      <TextV2
        typographyVariant="label4"
        {...restProps}
      >
        {formattedDuration}
      </TextV2>
    </GuestSiteTypographyOverride>
  );
};

EventCountdown.displayName = 'EventCountdown';

export { EventCountdown };
